import { Col, Media, Row } from 'reactstrap';
import { ContentBlock } from '../Shared/Content/ContentBlock';
import { ContentHeading } from '../Shared/Content/ContentHeading';
import { ContentBody } from '../Shared/Content/ContentBody';

interface IProps {
    fieldHowItWorksSectionTitle: string,
    fieldProgramSteps: any
}

export const ProjectSummary = ({ fieldHowItWorksSectionTitle, fieldProgramSteps }: IProps) => {
    return (
        <ContentBlock className="projectSummary">
            <ContentHeading title={fieldHowItWorksSectionTitle} />
            <ContentBody>
                <Row className="projectSummarySteps">
                    <Col>
                        {
                            fieldProgramSteps.map((data: any, index: number) => {
                                return (
                                data.fieldStepImage && data.fieldStepImage.url ? (
                                    <Row key={index} className={'projectSummaryStep projectSummaryStepColor' + data.fieldStepColor}>
                                        <Col sm={12} md={1} lg={1} className="projectSummaryStepNumber colorBox">{(index + 1)}</Col>
                                        <Col sm={12} md={10} lg={10} className="projectSummaryStepText" dangerouslySetInnerHTML={{ __html: data.fieldStepText }}></Col>
                                        <Col sm={12} md={1} lg={1} className="projectSummaryStepImage colorBox">
                                            <Media src={data.fieldStepImage.url} alt={data.fieldStepImage.alt} title={data.fieldStepImage.title} />
                                        </Col>
                                    </Row>
                                    ) : (
                                        <Row key={index} className={'projectSummaryStep projectSummaryStepColor' + data.fieldStepColor}>
                                            <Col sm={12} md={1} lg={1} className="projectSummaryStepNumber colorBox">{(index + 1)}</Col>
                                            <Col sm={12} md={11} lg={11} className="projectSummaryStepText" dangerouslySetInnerHTML={{ __html: data.fieldStepText }}></Col>
                                        </Row>
                                    )
                            )})
                        }
                    </Col>
                </Row>
            </ContentBody>
        </ContentBlock>
    );
};
